export const CLEAN_FORM = 'precios/reporteseguimientoprecios/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'precios/reporteseguimientoprecios/set-state-form';
export const UPDATE_FIELD_FILTER = 'precios/reporteseguimientoprecios/update-field-filter';
export const RECEIVE_V_LIST = 'precios/reporteseguimientoprecios/receive-v-list';
export const REQUEST_V_LIST = 'precios/reporteseguimientoprecios/request-v-list';
export const ERROR_V_LIST = 'precios/reporteseguimientoprecios/error-v-list';
export const SET_MASK = 'precios/reporteseguimientoprecios/set-mask';
export const SET_ORDER = 'precios/reporteseguimientoprecios/set-order';
export const RECEIVE_DATA= 'precios/reporteseguimientoprecios/receibe-data';
export const UPDATE_TABLE_COLUMN= 'precios/reporteseguimientoprecios/update-table-column';
export const SET_PAGE = 'precios/reporteseguimientoprecios/set-page';
export const SET_SELECTED_ROW = 'precios/reporteseguimientoprecios/set-selected-row';